import api from './api';

export const authService = {
  // Login - Step 1
  login: async (credentials) => {
    const response = await api.post('/auth/login', credentials);
    
    // If 2FA is required, don't store token yet
    if (response.data.requires2FA) {
      return response;
    }
    
    // If no 2FA required, store token and user
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response;
  },

  // Send 2FA code
  send2FACode: async (data) => {
    const response = await api.post('/auth/2fa/send', data);
    return response;
  },

  // Verify 2FA code
  verify2FA: async (data) => {
    const response = await api.post('/auth/2fa/verify', data);
    
    // Store token and user after successful 2FA
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response;
  },

  // Logout
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
  },

  // Get current user
  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  // Get user profile
  getProfile: async () => {
    const response = await api.get('/auth/profile');
    return response.data;
  },

  // Register agency agent
  registerAgencyAgent: async (data) => {
    const response = await api.post('/registration/agency', data);
    return response.data;
  },

  // Register independent agent
  registerIndependent: async (data) => {
    const response = await api.post('/registration/independent', data);
    return response.data;
  }
};